import React, { useEffect, useState } from "react";
import "./Analyse.css";
// Components
import { Containery } from "../../components/global/Container/container";
import ReactApexChart from "react-apexcharts";

export const Analyse = function () {

    const [ state , setState ] = useState({
        series: [{
          name: 'series1',
          data: [31, 40, 28, 51, 42, 109, 100]
        }, {
          name: 'series2',
          data: [11, 32, 45, 32, 34, 52, 41]
        }, {
            name: 'series2',
            data: [100, 12, 50, 20, 14, 82, 31]
        }],
        options: {
          chart: {
            height: 350,
            width: "100%",
            type: 'area'
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          xaxis: {
            type: 'datetime',
            categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },
          },
        },
      
      
      });

    return (
        <Containery>
            <div id="chart">
                <ReactApexChart 
                    options={state.options} 
                    series={state.series} 
                    type="area" 
                    height={250} 
                />
            </div>
        </Containery>
    );
}



